$(document).on('click', '.select-fdd-button', function() {
  $.get(`/components/non_inventory_brands/fdd_selector?brand_id=${$(this).attr('brand_id')}`).done(function(html) {
    const fddSelectorModal = $('#fdd-selector-modal')
    fddSelectorModal.find('.modal-content').html(html)
    fddSelectorModal.modal('show');
  });
});

// Ask Horizon to search Wisconsin's franchise registry for a brand that has no FDD yet.
// This is fire-and-forget: the response only confirms Horizon accepted the request, not that
// it found anything. If Horizon finds a viable FDD, it will show up here automatically later.
$(document).on('click', '#search-for-fdd-button', function () {
  const $button = $(this);
  const $result = $('#search-for-fdd-result');
  const brandId = $button.data('brand-id');

  $button.prop('disabled', true);
  $result.empty();

  $.post('/components/non_inventory_brands/fdd_selector/search_for_fdd', { brand_id: brandId }).done(function (data) {
    if (data.success) {
      $result.html('<div class="text-success">' + data.message + '</div>');
      return;
    }

    $result.html('<div class="text-danger">' + data.errors + '</div>');
    $button.prop('disabled', false);
  }).fail(function (jqXHR) {
    const message = (jqXHR.responseJSON && jqXHR.responseJSON.errors) || 'Something went wrong.';
    $result.html('<div class="text-danger">' + message + '</div>');
    $button.prop('disabled', false);
  });
});
